//This javascript file contains a function which ONLY returns an array of objects(locations)

//Original document https://docs.google.com/spreadsheets/d/16cW0uImW8qXokaafUNgothXZG0UoZG92x8mMM_z-2iU/edit#gid=0
// CSV to JSON Converter http://www.convertcsv.com/csv-to-json.htm

export default function coordinates() {
  return [
    {
      continent: "Africa",
      country: "South Africa",
      city: "Cape Town",
      lat: -33.9891411,
      long: 18.4260155
    },
    {
      continent: "Africa",
      country: "Kenya",
      city: "Nairobi",
      lat: -1.2817478,
      long: 36.8217704
    },
    {
      continent: "Africa",
      country: "Tunisia",
      city: "Karthago",
      lat: 36.8697316,
      long: 10.3437646
    },
    {
      continent: "Africa",
      country: "Ghana",
      city: "Accra",
      lat: 5.5680937,
      long: -0.1694378
    },
    {
      continent: "Africa",
      country: "Ghana",
      city: "Accra",
      lat: 5.5680937,
      long: -0.1694378
    },
    {
      continent: "Africa",
      country: "Kenya",
      city: "Nairobi",
      lat: -1.3827504,
      long: 36.8196892
    },
    {
      continent: "Africa",
      country: "Botswana",
      city: "Orapa",
      lat: -21.328576,
      long: 25.428519
    },
    {
      continent: "Africa",
      country: "Cape Verde",
      city: "Praia",
      lat: 14.914455,
      long: -23.510998
    },
    {
      continent: "Africa",
      country: "Ghana",
      city: "Wa",
      lat: 10.060861,
      long: -2.498717
    },
    {
      continent: "Africa",
      country: "Kenya",
      city: "Mombasa",
      lat: -4.09354,
      long: 39.673661
    },
    {
      continent: "Africa",
      country: "Senegal",
      city: "Saint-Louis",
      lat: 16.02577,
      long: -16.50135
    },
    {
      continent: "Africa",
      country: "Tunisia",
      city: "Monastir",
      lat: 35.772725,
      long: 10.833142
    },
    {
      continent: "Africa",
      country: "Kenya",
      city: "Nairobi",
      lat: -1.612183,
      long: 36.899584
    },
    {
      continent: "Africa",
      country: "South Africa",
      city: "Cape town",
      lat: -33.90443,
      long: 18.4208346
    },
    {
      continent: "Asia",
      country: "Jordan",
      city: "Amman",
      lat: 31.9535366,
      long: 35.9328592
    },
    {
      continent: "Asia",
      country: "Israel",
      city: "Jerusalem",
      lat: 31.7778687,
      long: 35.2331645
    },
    {
      continent: "Asia",
      country: "Philippines",
      city: "Manila",
      lat: 14.5918643,
      long: 120.973878
    },
    {
      continent: "Asia",
      country: "Japan",
      city: "Takamtsu",
      lat: 34.32243934323995,
      long: 134.07869487737094
    },
    {
      continent: "Asia",
      country: "Malaysia",
      city: "Singapore",
      lat: 1.2947476,
      long: 103.8923484
    },
    {
      continent: "Asia",
      country: "Thailand",
      city: "Bangkok",
      lat: 13.7392888,
      long: 100.4974982
    },
    {
      continent: "Asia",
      country: "Japan",
      city: "Tokyo",
      lat: 35.6421632,
      long: 139.7142181
    },
    {
      continent: "Asia",
      country: "China",
      city: "Hong Kong",
      lat: 22.3089001,
      long: 114.1900167
    },
    {
      continent: "Asia",
      country: "Malaysia",
      city: "Taiping",
      lat: 4.84888,
      long: 100.751315
    },
    {
      continent: "Asia",
      country: "Indonesia",
      city: "Jakarta",
      lat: -6.195139,
      long: 106.823563
    },
    {
      continent: "Asia",
      country: "Malaysia",
      city: "Karak",
      lat: 3.302087,
      long: 102.077375
    },
    {
      continent: "Asia",
      country: "Thailand",
      city: "Bangkok",
      lat: 13.725264,
      long: 100.522987
    },
    {
      continent: "Asia",
      country: "United Arab Emirates",
      city: "Dubai",
      lat: 25.134001,
      long: 55.152008
    },
    {
      continent: "Asia",
      country: "Lebanon",
      city: "Beirut",
      lat: 33.900282,
      long: 35.4807439
    },
    {
      continent: "Asia",
      country: "Singapore",
      city: "Singapore",
      lat: 1.286099,
      long: 103.861643
    },
    {
      continent: "Asia",
      country: "Japan",
      city: "Hakuba",
      lat: 36.747081,
      long: 137.868173
    },
    {
      continent: "Asia",
      country: "Japan",
      city: "Tokyo",
      lat: 35.659424,
      long: 139.700705
    },
    {
      continent: "Asia",
      country: "Japan",
      city: "Tokyo",
      lat: 35.659415,
      long: 139.699773
    },
    {
      continent: "Asia",
      country: "South Korea",
      city: "Seoul",
      lat: 37.581643,
      long: 126.985052
    },
    {
      continent: "Europe",
      country: "Finland",
      city: "Laupa",
      lat: 62.973187,
      long: 23.000375
    },
    {
      continent: "Europe",
      country: "Slovenia",
      city: "Zalec",
      lat: 46.284949,
      long: 15.182765
    },
    {
      continent: "Europe",
      country: "Slovakia",
      city: "Košice",
      lat: 48.72058,
      long: 21.258521
    },
    {
      continent: "Europe",
      country: "Croatia",
      city: "Mali Lošinj",
      lat: 44.532493,
      long: 14.478738
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Porto Azzurro LI",
      lat: 42.764852,
      long: 10.395783
    },
    {
      continent: "Europe",
      country: "France",
      city: "Ajaccio",
      lat: 41.933892,
      long: 8.750805
    },
    {
      continent: "Europe",
      country: "Sweden",
      city: "Stockholm",
      lat: 59.404083,
      long: 17.949143
    },
    {
      continent: "Europe",
      country: "Denmark",
      city: "Öresund",
      lat: 55.5757011,
      long: 12.8244315
    },
    {
      continent: "Europe",
      country: "Czech Republic",
      city: "Prague",
      lat: 50.084765,
      long: 14.420865
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Taormina",
      lat: 37.8547834,
      long: 15.2911333
    },
    {
      continent: "Europe",
      country: "France",
      city: "Paris",
      lat: 48.8006999,
      long: 2.2900592
    },
    {
      continent: "Europe",
      country: "Portugal",
      city: "Lisbon",
      lat: 38.708265,
      long: -9.1368961
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Verona",
      lat: 45.4390995,
      long: 10.9933283
    },
    {
      continent: "Europe",
      country: "Turkey",
      city: "Istanbul",
      lat: 41.0055659,
      long: 28.9738239
    },
    {
      continent: "Europe",
      country: "France",
      city: "Nice",
      lat: 43.694845,
      long: 7.268124
    },
    {
      continent: "Europe",
      country: "Malta",
      city: "Sliema",
      lat: 35.907995,
      long: 14.511485
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Amalfi",
      lat: 40.63412,
      long: 14.602596
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Venice",
      lat: 45.437083,
      long: 12.334515
    },
    {
      continent: "Europe",
      country: "Switzerland",
      city: "Geneva",
      lat: 46.203797,
      long: 6.151254
    },
    {
      continent: "Europe",
      country: "Russia",
      city: "Novonikolayevsky District",
      lat: 50.82256406223808,
      long: 42.44466931974307
    },
    {
      continent: "Europe",
      country: "Germany",
      city: "Saschensross",
      lat: 52.3817749,
      long: 9.7176809
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Lagundo",
      lat: 46.6870238,
      long: 11.1282462
    },
    {
      continent: "Europe",
      country: "Hungary",
      city: "Budapest",
      lat: 47.506754,
      long: 19.0448758
    },
    {
      continent: "Europe",
      country: "Romania",
      city: "Bucarest",
      lat: 44.4269527,
      long: 26.0908002
    },
    {
      continent: "Europe",
      country: "Russia",
      city: "Odessa",
      lat: 46.4848874,
      long: 30.7420723
    },
    {
      continent: "Europe",
      country: "Sweden",
      city: "Uppsala",
      lat: 59.8578005,
      long: 17.6372415
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Porto Santo Stefano",
      lat: 42.438992,
      long: 11.1166591
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Porto Santo Stefano",
      lat: 42.438992,
      long: 11.1166591
    },
    {
      continent: "Europe",
      country: "Sweden",
      city: "Grangärde",
      lat: 60.32039070374471,
      long: 15.061796518497658
    },
    {
      continent: "Europe",
      country: "Czech Republic",
      city: "Pozořice",
      lat: 49.21237574879927,
      long: 16.79367508630594
    },
    {
      continent: "Europe",
      country: "Sweden",
      city: "Västerås",
      lat: 59.6129143,
      long: 16.5495753
    },
    {
      continent: "Europe",
      country: "Denmark",
      city: "Odense",
      lat: 55.3900511,
      long: 10.3809715
    },
    {
      continent: "Europe",
      country: "Norway",
      city: "Tromsø",
      lat: 69.6607156,
      long: 18.9076949
    },
    {
      continent: "Europe",
      country: "Russia",
      city: "Voronezj",
      lat: 51.28801934333628,
      long: 42.05600334677422
    },
    {
      continent: "Europe",
      country: "Albania",
      city: "Tirana",
      lat: 41.330999,
      long: 19.812361
    },
    {
      continent: "Europe",
      country: "Andorra",
      city: "Santa Coloma",
      lat: 42.503522,
      long: 1.519588
    },
    {
      continent: "Europe",
      country: "Italy",
      city: "Bolzano",
      lat: 46.647252,
      long: 11.903373
    },
    {
      continent: "North America",
      country: "Guatemala",
      city: "Guatemala City",
      lat: 14.61254,
      long: -90.514376
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "San Jose",
      lat: 37.344435,
      long: -121.8938691
    },
    {
      continent: "North America",
      country: "Mexico",
      city: "Merida",
      lat: 20.9675177,
      long: -89.6231581
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Miami",
      lat: 25.8512923,
      long: -80.1187568
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Kingsport",
      lat: 36.5510443,
      long: -82.5489313
    },
    {
      continent: "North America",
      country: "Bermuda",
      city: "St.George's",
      lat: 32.381328,
      long: -64.677409
    },
    {
      continent: "North America",
      country: "Canada",
      city: "Vancouver",
      lat: 49.279457,
      long: -123.098371
    },
    {
      continent: "North America",
      country: "Curacao",
      city: "Willemstad",
      lat: 12.10615,
      long: -68.935414
    },
    {
      continent: "North America",
      country: "Dominican Republic",
      city: "Santo Domingo",
      lat: 18.47534,
      long: -69.884744
    },
    {
      continent: "North America",
      country: "Greenland",
      city: "Narsaq",
      lat: 60.9116431,
      long: -46.050871
    },
    {
      continent: "North America",
      country: "Puerto Rico",
      city: "San Juan",
      lat: 18.45412,
      long: -66.095092
    },
    {
      continent: "North America",
      country: "Saint Pierre and Miquelon",
      city: "Miquelon",
      lat: 47.102731,
      long: -56.375371
    },
    {
      continent: "North America",
      country: "Mexico",
      city: "Tulum ",
      lat: 20.21593,
      long: -87.428476
    },
    {
      continent: "North America",
      country: "Mexico",
      city: "Chichen Itza",
      lat: 20.682444,
      long: -88.569333
    },
    {
      continent: "North America",
      country: "Mexico",
      city: "Zocalo",
      lat: 19.432903,
      long: -99.133236
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Shelbyville",
      lat: 39.84453122003536,
      long: -91.91848038083248
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Kansas",
      lat: 38.9314775,
      long: -94.8979853
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Boston",
      lat: 42.345573,
      long: -71.098326
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Elmore Ciry",
      lat: 34.56498816763528,
      long: -97.44588724772893
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Marion",
      lat: 35.73869098766281,
      long: -82.04899203997479
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Adelaide",
      lat: -35.01371,
      long: 138.552653
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Surfers Paradise",
      lat: -28.00296,
      long: 153.43115
    },
    {
      continent: "Oceania",
      country: "American Samoa",
      city: "Fagasa",
      lat: -14.28638,
      long: -170.720715
    },
    {
      continent: "Oceania",
      country: "Guam",
      city: "Talofofo",
      lat: 13.360338,
      long: 144.771535
    },
    {
      continent: "Oceania",
      country: "French Polynesia",
      city: "Papeete",
      lat: -17.540037,
      long: -149.567458
    },
    {
      continent: "Oceania",
      country: "Northern Mariana Islands",
      city: "Susupe",
      lat: 15.156691,
      long: 145.700898
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Days Bay",
      lat: -41.282191,
      long: 174.90647
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Padthaway",
      lat: -36.60348967620079,
      long: 140.61520844792608
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Pukeawa",
      lat: -46.1511089738839,
      long: 169.60730292402445
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Uluru",
      lat: -25.356019,
      long: 131.0179079
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Awakino",
      lat: -38.64467208222382,
      long: 174.66896687084454
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "São Luís",
      lat: -2.523698,
      long: -44.295937
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Paracas",
      lat: -13.832766,
      long: -76.248515
    },

    {
      continent: "South America",
      country: "Argentina",
      city: "Santa Fe",
      lat: -31.604668,
      long: -60.672017
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "Juma",
      lat: -5.3700293,
      long: -60.4355699
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "Sao Paulo",
      lat: -23.5463055,
      long: -46.6350131
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "Rio de Janeiro",
      lat: -22.9657593,
      long: -43.1711172
    },
    {
      continent: "South America",
      country: "Colombia",
      city: "Bogotà",
      lat: 4.6934493,
      long: -74.0864551
    },

    {
      continent: "South America",
      country: "Colombia",
      city: "Medellin",
      lat: 6.238731,
      long: -75.565078
    },

    {
      continent: "South America",
      country: "Colombia",
      city: "Potosi",
      lat: 0.8044996,
      long: -77.5852833
    },
    {
      continent: "South America",
      country: "Ecuador",
      city: "Quito",
      lat: -0.1817912,
      long: -78.4802128
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Huacachina",
      lat: -14.0864947,
      long: -75.7642558
    },
    {
      continent: "North America",
      country: "Antigua and Barbuda",
      city: "Pond Hill",
      lat: 17.1230824,
      long: -62.5945344
    },
    {
      continent: "North America",
      country: "Aruba",
      city: "Eagle Beach",
      lat: 12.5519333,
      long: -70.0563628
    },
    {
      continent: "North America",
      country: "Bahamas",
      city: "Nassau",
      lat: 25.0805904,
      long: -77.3100893
    },
    {
      continent: "North America",
      country: "Beliz",
      city: "Hopkins",
      lat: 16.8267437,
      long: -88.2669964
    },
    {
      continent: "North America",
      country: "Bermuda",
      city: "Somerser Village",
      lat: 32.303135,
      long: -64.8610673
    },
    {
      continent: "North America",
      country: "British Virgin Islands",
      city: "Long Bay",
      lat: 18.3975792,
      long: -64.6920242
    },
    {
      continent: "North America",
      country: "Canada",
      city: "Detah",
      lat: 62.4213069,
      long: -114.3275098
    },
    {
      continent: "North America",
      country: "Canada",
      city: "Ontario",
      lat: 43.0851958,
      long: -79.0733428
    },
    {
      continent: "North America",
      country: "Canada",
      city: "Vancouver",
      lat: 49.309672,
      long: -123.1536722
    },
    {
      continent: "North America",
      country: "Cayman Islands",
      city: "Cypress Pointe",
      lat: 19.348633,
      long: -81.370678
    },
    {
      continent: "North America",
      country: "Costa Rica",
      city: "San José",
      lat: 9.914916,
      long: -84.0735518
    },
    {
      continent: "North America",
      country: "Cuba",
      city: "Havana",
      lat: 23.1348437,
      long: -82.3588543
    },
    {
      continent: "North America",
      country: "Dominica",
      city: "",
      lat: 15.3273881,
      long: -61.3357355
    },
    {
      continent: "North America",
      country: "Dominican Republic",
      city: "Puerto Plata",
      lat: 19.7926607,
      long: -70.6764703
    },
    {
      continent: "North America",
      country: "El Salvador",
      city: "San Salvador",
      lat: 13.7015478,
      long: -89.2210925
    },
    {
      continent: "North America",
      country: "Guadeloupe",
      city: "La Datcha",
      lat: 16.2050971,
      long: -61.4930221
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Days Bay",
      lat: -41.282191,
      long: 174.90647
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Padthaway",
      lat: -36.60348967620079,
      long: 140.61520844792608
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Pukeawa",
      lat: -46.1511089738839,
      long: 169.60730292402445
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Uluru",
      lat: -25.356019,
      long: 131.0179079
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Awakino",
      lat: -38.64467208222382,
      long: 174.66896687084454
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "São Luís",
      lat: -2.523698,
      long: -44.295937
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Paracas",
      lat: -13.832766,
      long: -76.248515
    },
    {
      continent: "South America",
      country: "Uruguay",
      city: "Montevideo",
      lat: -34.906495,
      long: -56.200102
    },
    {
      continent: "South America",
      country: "Argentina",
      city: "Santa Fe",
      lat: -31.604668,
      long: -60.672017
    },
    {
      continent: "Europe",
      country: "Albania",
      city: "Shkodër",
      lat: 42.0749955,
      long: 19.5157058
    },
    {
      continent: "Europe",
      country: "Andorra",
      city: "Escaldes-Engordany",
      lat: 42.5047919,
      long: 1.5397686
    },
    {
      continent: "Europe",
      country: "Armenia",
      city: "Yerevan",
      lat: 40.1779078,
      long: 44.5127277
    },
    {
      continent: "Europe",
      country: "Azerbaijan",
      city: "Guvernementet Baku",
      lat: 40.3718165,
      long: 49.8506666
    },
    {
      continent: "Europe",
      country: "Belgium",
      city: "Bastogne",
      lat: 50.0094049,
      long: 5.7390436
    },
    {
      continent: "Europe",
      country: "Bulgaria",
      city: "Obzor",
      lat: 42.8239913,
      long: 27.8816925
    },
    {
      continent: "Europe",
      country: "Estonia",
      city: "Tallinn",
      lat: 59.4418625,
      long: 24.7488913
    },
    {
      continent: "Europe",
      country: "Georgia",
      city: "Tbilisi",
      lat: 41.7153786,
      long: 44.7938185
    },
    {
      continent: "Europe",
      country: "Greece",
      city: "Chania",
      lat: 35.5161109,
      long: 24.0161344
    },
    {
      continent: "Europe",
      country: "Iceland",
      city: "Höfn",
      lat: 64.2504712,
      long: -15.2048571
    },
    {
      continent: "Europe",
      country: "Ireland",
      city: "Limerick",
      lat: 52.6600683,
      long: -8.627511
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "Juma",
      lat: -5.3700293,
      long: -60.4355699
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "Sao Paulo",
      lat: -23.5463055,
      long: -46.6350131
    },
    {
      continent: "South America",
      country: "Brazil",
      city: "Rio de Janeiro",
      lat: -22.9657593,
      long: -43.1711172
    },
    {
      continent: "South America",
      country: "Colombia",
      city: "Bogotà",
      lat: 4.6934493,
      long: -74.0864551
    },
    {
      continent: "South America",
      country: "Colombia",
      city: "Medellin",
      lat: 6.238731,
      long: -75.565078
    },
    {
      continent: "South America",
      country: "Colombia",
      city: "Potosi",
      lat: 0.8044996,
      long: -77.5852833
    },
    {
      continent: "South America",
      country: "Ecuador",
      city: "Quito",
      lat: -0.1817912,
      long: -78.4802128
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Huacachina",
      lat: -14.0864947,
      long: -75.7642558
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Cuzco",
      lat: -13.5169533,
      long: -71.9791645
    },
    {
      continent: "South America",
      country: "Bolivia",
      city: "La Paz",
      lat: -16.5028553,
      long: -68.1190812
    },
    {
      continent: "South America",
      country: "Bolivia",
      city: "Santa cruz de la Sierra",
      lat: -17.7835818,
      long: -63.1816385
    },
    {
      continent: "South America",
      country: "Paraguay",
      city: "Asunción",
      lat: -25.2949665,
      long: -57.5800693
    },
    {
      continent: "South America",
      country: "Uruguay",
      city: "Montevideo",
      lat: -34.9069726,
      long: -56.1995649
    },
    {
      continent: "South America",
      country: "Sandwich Islands",
      city: "Slappen",
      lat: -54.2838716,
      long: -36.5081909
    },
    {
      continent: "South America",
      country: "Argentina",
      city: "Buenos Aires",
      lat: -34.6099746,
      long: -58.391436
    },
    {
      continent: "South America",
      country: "Argentina",
      city: "Buenos Aires",
      lat: -34.6099746,
      long: -58.391436
    },
    {
      continent: "South America",
      country: "Chile",
      city: "Santiago",
      lat: -33.4571916,
      long: -70.659616
    },
    {
      continent: "Asia",
      country: "Kyrgyzstan",
      city: "Bisjkek",
      lat: 42.8755784,
      long: 74.6040764
    },
    {
      continent: "Asia",
      country: "Sri Lanka",
      city: "Sigiriya",
      lat: 7.9551769,
      long: 80.756694
    },

    {
      continent: "Africa",
      country: "Eswatini",
      city: "Kwaluseni",
      lat: -26.49038,
      long: 31.366
    },
    {
      continent: "Africa",
      country: "Lesotho",
      city: "Sehlabathebe",
      lat: -29.8699184,
      long: 29.0676277
    },
    {
      continent: "Africa",
      country: "Madagascar",
      city: "Ambanja",
      lat: -13.7497672,
      long: 48.4573467
    },
    {
      continent: "Africa",
      country: "Morocco",
      city: "Rabat",
      lat: 34.2629347,
      long: -6.5842428
    },
    {
      continent: "Africa",
      country: "Namibia",
      city: "Swakopmund",
      lat: -22.6696626,
      long: 14.8177945
    },

    {
      continent: "Africa",
      country: "Nigeria",
      city: "Lagos",
      lat: 6.4883654,
      long: 3.3061398
    },

    {
      continent: "Africa",
      country: "Rwanda",
      city: "Kigali",
      lat: -1.9541985,
      long: 30.0804535
    },

    {
      continent: "Africa",
      country: "Senegal",
      city: "Tambacounda",
      lat: 13.9385779,
      long: -14.2970438
    },
    {
      continent: "Africa",
      country: "Tanzania",
      city: "Karatu",
      lat: -3.1782518,
      long: 35.4734978
    },
    {
      continent: "Africa",
      country: "Zimbabwe",
      city: "Harare",
      lat: -17.7833528,
      long: 31.1192688
    },
    {
      continent: "Asia",
      country: "Laos",
      city: "Vang Vieng",
      lat: 18.9280921,
      long: 102.4474985
    },
    {
      continent: "Asia",
      country: "Myanmar",
      city: "Vang Vieng",
      lat: 19.7710088,
      long: 96.1843961
    },
    {
      continent: "Asia",
      country: "Bangladesh",
      city: "Dhaka",
      lat: 23.7188545,
      long: 90.3874263
    },
    {
      continent: "Asia",
      country: "Malaysia",
      city: "Kuala Lumpur",
      lat: 3.1569733,
      long: 101.7135137
    },

    {
      continent: "Asia",
      country: "Armenia",
      city: "Kuala Lumpur",
      lat: 40.1772503,
      long: 101.7135137
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Huacachina",
      lat: -14.0864947,
      long: -75.7642558
    },
    {
      continent: "Oceania",
      country: "Indonesia",
      city: "Sulawesi Selatan",
      lat: -5.1369951,
      long: 119.4053145
    },
    {
      continent: "Oceania",
      country: "Indonesia",
      city: "Sulawesi Selatan",
      lat: -5.1369951,
      long: 119.4053145
    },
    {
      continent: "Oceania",
      country: "New Zealand",
      city: "Wellington",
      lat: -41.3036735,
      long: 174.8309712
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Albert Park",
      lat: -37.8501916,
      long: 144.9691386
    },
    {
      continent: "Asia",
      country: "Vietnam",
      city: "Albert Park",
      lat: 20.9469931,
      long: 107.0816821
    },
    {
      continent: "Asia",
      country: "China",
      city: "Hongkong",
      lat: 22.3056217,
      long: 114.1688934
    },
    {
      continent: "Asia",
      country: "Taiwan",
      city: "Taoyuan",
      lat: 24.9604205,
      long: 121.2196972
    },
    {
      continent: "Asia",
      country: "Taiwan",
      city: "Taoyuan",
      lat: 24.9604205,
      long: 121.2196972
    },
    {
      continent: "Asia",
      country: "Japan",
      city: "Tokyo",
      lat: 35.6730397,
      long: 139.7815827
    },
    {
      continent: "Asia",
      country: "Mongolia",
      city: "Ulan Bator",
      lat: 47.9191756,
      long: 106.9180226
    },
    {
      continent: "Asia",
      country: "United Arab Emirates",
      city: "Dubai",
      lat: 25.2162571,
      long: 55.2819811
    },
    {
      continent: "Africa",
      country: "South Africa",
      city: "Cape Town",
      lat: -34.2583037,
      long: 18.4718761
    },
    {
      continent: "North America",
      country: "United States of America",
      city: "Miami",
      lat: 25.8737826,
      long: -80.1197774
    },
    {
      continent: "Africa",
      country: "Eswatini",
      city: "Kwaluseni",
      lat: -26.49038,
      long: 31.366
    },
    {
      continent: "Africa",
      country: "Lesotho",
      city: "Sehlabathebe",
      lat: -29.8699184,
      long: 29.0676277
    },
    {
      continent: "Africa",
      country: "Madagascar",
      city: "Ambanja",
      lat: -13.7497672,
      ong: 48.4573467
    },
    {
      continent: "Africa",
      country: "Morocco",
      city: "Rabat",
      lat: 34.2629347,
      long: -6.5842428
    },
    {
      continent: "Africa",
      country: "Namibia",
      city: "Swakopmund",
      lat: -22.6696626,
      long: 14.8177945
    },
    {
      continent: "Africa",
      country: "Nigeria",
      city: "Lagos",
      lat: 6.4883654,
      long: 3.3061398
    },
    {
      continent: "Africa",
      country: "Rwanda",
      city: "Kigali",
      lat: -1.9541985,
      long: 30.0804535
    },
    {
      continent: "Africa",
      country: "Senegal",
      city: "Tambacounda",
      lat: 13.9385779,
      long: -14.2970438
    },
    {
      continent: "Africa",
      country: "Tanzania",
      city: "Karatu",
      lat: -3.1782518,
      long: 35.4734978
    },
    {
      continent: "Africa",
      country: "Zimbabwe",
      city: "Harare",
      lat: -17.7833528,
      long: 31.1192688
    },
    {
      continent: "Asia",
      country: "Laos",
      city: "Vang Vieng",
      lat: 18.9280921,
      long: 102.4474985
    },
    {
      continent: "Asia",
      country: "Myanmar",
      city: "Vang Vieng",
      lat: 19.7710088,
      long: 96.1843961
    },
    {
      continent: "Asia",
      country: "Bangladesh",
      city: "Dhaka",
      lat: 23.7188545,
      long: 90.3874263
    },
    {
      continent: "Asia",
      country: "Malaysia",
      city: "Kuala Lumpur",
      lat: 3.1569733,
      long: 101.7135137
    },
    {
      continent: "Asia",
      country: "Armenia",
      city: "Kuala Lumpur",
      lat: 40.1772503,
      long: 101.7135137
    },
    {
      continent: "South America",
      country: "Peru",
      city: "Huacachina",
      lat: -14.0864947,
      long: -75.7642558
    },
    {
      continent: "North America",
      country: "US Virgin Islands",
      city: "Christiansted",
      lat: 17.7542901,
      long: -64.6087508
    },
    {
      continent: "Oceania",
      country: "Cook Islands",
      city: "Rarotonga",
      lat: -21.2388277,
      long: -159.7318996
    },

    {
      continent: "Oceania",
      country: "Fiji",
      city: "Nadi",
      lat: -17.7146941,
      long: 177.5264046
    },
    {
      continent: "Oceania",
      country: "Pitcairn Islands",
      city: "Henderson",
      lat: -24.3388895,
      long: -128.3335986
    },

    {
      continent: "Oceania",
      country: "Tonga",
      city: "Houma",
      lat: -21.1832039,
      long: -175.2210326
    },

    {
      continent: "Oceania",
      country: "Vanuatu",
      city: "Ambrym",
      lat: -16.2493196,
      long: 168.1371995
    },
    {
      continent: "Oceania",
      country: "Australia",
      city: "Karijini",
      lat: -22.4755322,
      long: 118.5520838
    },

    {
      continent: "Europe",
      country: "Latvia",
      city: "Jekabpils",
      lat: 56.1360743,
      long: 25.9871137
    },

    {
      continent: "Europe",
      country: "Lithuania",
      city: "Preila",
      lat: 55.3453617,
      long: 21.1935946
    },
    {
      continent: "Europe",
      country: "Luxembourg",
      city: "Luxembourg",
      lat: 49.6116699,
      long: 6.1361671
    },

    {
      continent: "Europe",
      country: "Moldova",
      city: "Chisinau",
      lat: 47.0171961,
      long: 28.8318372
    },

    {
      continent: "Europe",
      country: "Monaco",
      city: "La Condamine",
      lat: 43.7335512,
      long: 7.4248564
    },

    {
      continent: "Europe",
      country: "Montenegro",
      city: "Niksic",
      lat: 42.8058953,
      long: 18.9324925
    },
    {
      continent: "Europe",
      country: "Netherlands",
      city: "Amsterdam",
      lat: 52.2593823,
      long: 5.0949006
    },
    {
      continent: "Europe",
      country: "North Macedonia",
      city: "Stochno Pazarishte",
      lat: 41.3342056,
      long: 21.5354986
    },
    {
      continent: "Europe",
      country: "Poland",
      city: "Janowiec",
      lat: 51.3244891,
      long: 21.8943357
    },
    {
      continent: "Europe",
      country: "San Marino",
      city: "San Marino",
      lat: 43.9347749,
      long: 12.458259
    },
    {
      continent: "Europe",
      country: "Serbia",
      city: "Belgrad",
      lat: 44.9367409,
      long: 19.899881
    },
    {
      continent: "Europe",
      country: "Spain",
      city: "Malaga",
      lat: 36.6781056,
      long: -4.4472331
    },
    {
      continent: "Europe",
      country: "Ukraine",
      city: "Donetsk",
      lat: 47.9504708,
      long: 37.6918893
    },
    {
      continent: "Europe",
      country: "United Kingdom",
      city: "Newcastle upon Tyle",
      lat: 54.4896681,
      long: -0.6046186
    },
    {
      continent: "Europe",
      country: "Sweden",
      city: "Stockholm",
      lat: 59.3887334,
      long: 17.7783782
    },
    {
      continent: "Asia",
      country: "Bahrain",
      city: "Zallaq",
      lat: 26.0092077,
      long: 50.5082165
    },

    {
      continent: "Asia",
      country: "Bhutan",
      city: "Trashigang",
      lat: 27.3053583,
      long: 91.5407736
    },
    {
      continent: "Asia",
      country: "Cambodia",
      city: "Stung Treng",
      lat: 13.427979,
      long: 106.0763091
    },
    {
      continent: "Asia",
      country: "Cyprus",
      city: "Tepe Mahallesi",
      lat: 35.1177263,
      long: 32.8501852
    },
    {
      continent: "Asia",
      country: "Georgia",
      city: "Tbilisi",
      lat: 41.8417666,
      long: 44.7205904
    },
    {
      continent: "Asia",
      country: "India",
      city: "New Delhi",
      lat: 28.6563936,
      long: 77.2289909
    },
    {
      continent: "Asia",
      country: "Iran",
      city: "Gach Sar",
      lat: 36.0181538,
      long: 51.2704524
    },

    {
      continent: "Asia",
      country: "Iraq",
      city: "Bagdad",
      lat: 33.3283159,
      long: 44.3851686
    },

    {
      continent: "Asia",
      country: "Kyrgyzstan",
      city: "Issyk-Kul",
      lat: 42.7381944,
      long: 77.8164066
    },

    {
      continent: "Asia",
      country: "Mongolia",
      city: "Archangaj",
      lat: 47.4807203,
      long: 101.451572
    },
    {
      continent: "Asia",
      country: "Nepal",
      city: "Khumjung",
      lat: 27.8358609,
      long: 86.7636767
    },
    {
      continent: "Asia",
      country: "Pakistan",
      city: "Lahore",
      lat: 31.573548,
      long: 74.3067484
    },
    {
      continent: "Asia",
      country: "Qatar",
      city: "Doha",
      lat: 25.3092752,
      long: 51.4456979
    },
    {
      continent: "Asia",
      country: "Taiwan",
      city: "Jiayi",
      lat: 23.6028065,
      long: 120.666032
    },
    {
      continent: "Asia",
      country: "Vietnam",
      city: "Hanoi",
      lat: 21.0134072,
      long: 105.8270485
    }
  ];
}
